const ContactMapSection = () => {
  return (
    <section id="contact-section">
      <div className="w-full h-[300px]">
        <iframe
          className="w-full h-full border-0"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d860.7063800457665!2d78.01210756961424!3d30.355908255666264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3908d5e48cec4f93%3A0x1063d531e956cc15!2sUttarakhand%20Tourism%20Development%20Board%20Office!5e0!3m2!1sen!2sin!4v1744874267632!5m2!1sen!2sin"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactMapSection;
